<div class="section-header" [class.section-header--bare]="!title">
  <div class="section-title-container" *ngIf="title">
    <h2 class="section-title">{{ title }}</h2>
    <div class="help-tooltip-container" *ngIf="helpText || resolvedHelpUrl">
      <span class="help-tooltip-icon">
        <i class="fa fa-question-circle"></i>
      </span>
      <div class="help-tooltip-content">
        <div *ngIf="helpText" class="help-description">{{ helpText }}</div>
        <a
          *ngIf="!isLoadingHelp && resolvedHelpUrl"
          class="help-link"
          [href]="resolvedHelpUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa fa-external-link-alt"></i> Learn more
        </a>
      </div>
    </div>
  </div>
  <!-- Bare row: the filters share the action row, left of the action. -->
  <div class="section-filters" *ngIf="!title">
    <ng-container *ngTemplateOutlet="filtersContent"></ng-container>
  </div>
  <div class="section-actions">
    <ng-content></ng-content>
  </div>
</div>
<div class="section-divider" *ngIf="title"></div>
<!-- Titled section: the filters get their own row under the heading, directly
     above the list. -->
<div class="section-filters section-filters--row" *ngIf="title">
  <ng-container *ngTemplateOutlet="filtersContent"></ng-container>
</div>

<!-- The ONE [filters] slot (CHAT-1152). Angular projects into a single
     <ng-content> per selector, so the two placements above stamp this template
     rather than each declaring a slot of their own. -->
<ng-template #filtersContent><ng-content select="[filters]"></ng-content></ng-template>
